<!--
 * @Author: xiaokun
 * @Date: 2020-04-13 22:00:28
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-13 22:08:03
 * @Description: 是否通过
 -->
<template>
  <div class="list-table-pass">
    {{ pass }}
  </div>
</template>
<script>
export default {
  name: 'ListTablePass',
  components: {},
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    pass () {
      return this.scope.row.pass === 1 ? '已通过' : '未通过'
    }
  }
}
</script>
